import './index.scss'
import React from 'react'
import { Link } from 'gatsby'

function SplitView({
  displayImageLeft,
  title,
  text,
  linkText,
  link,
  backgroundImage,
  listHeading,
  listDescription,
  lists,
  textBoxes,
  small,
  mid,
  backgroundColor,
  center,
  noSpace,
  noSpaceTop,
  HeadlineLevel = 'h2',
  backgroundImageSize,
  backgroundImageText,
}) {
  const imagePosition = displayImageLeft ? 'left' : 'right'
  const contentPosition = !center ? 'flex-start !important' : ''

  function setImageStyle() {
    if (small) {
      return { height: '300px' }
    } else if (mid) {
      return { height: '500px' }
    }
    return {}
  }

  const splitViewStyle = {
    backgroundColor: backgroundColor || '',
  }

  const contentStyle = {
    justifyContent: `${contentPosition}`,
  }

  return (
    <div
      className={`split-view split-view--${imagePosition} split-view--${noSpace ? 'no-space' : 'space'} split-view--${noSpaceTop ? 'no-space-top' : ''}`}
      style={splitViewStyle}
    >
      <div className="container">
        <div className="split-view__wrapper">
          <div className="split-view__content" style={contentStyle}>
            <HeadlineLevel>{title}</HeadlineLevel>
            <span>{text}</span>
            {!lists && !textBoxes && link && linkText && (
              <a href={link} className="cta-round cta-round--on-text">
                <span>
                  <a>{linkText}</a>
                </span>
                <svg viewBox="0 0 13 10" height="10px" width="15px">
                  <path d="M1,5 L11,5"></path>
                  <polyline points="8 1 12 5 8 9"></polyline>
                </svg>
              </a>
            )}
          </div>
          <div className="split-view__image" style={setImageStyle()}>
            {backgroundImage && (
              <img
                className={`split-view__image-img${backgroundImageSize === 'small' ? '-small' : ''}`}
                src={`${backgroundImage}`}
                alt=""
                loading="lazy"
              />
            )}
            <p className="split-view__image-text">{backgroundImageText}</p>
          </div>
          {lists && (
            <div
              className={
                'split-view__lists ' + (lists.length > 2 ? 'columns' : 'rows')
              }
            >
              {(listHeading || listDescription) && (
                <div className="lists-heading">
                  {listHeading && <h4>{listHeading}</h4>}
                  {listDescription && <p>{listDescription}</p>}
                </div>
              )}
              {lists.map((list, i) => {
                return (
                  <div className="list" key={'list' + i}>
                    {list.head && (
                      <div className="list-heading">{list.head}</div>
                    )}
                    <ul className="list-content">
                      {list.content.map((bulletPoint, j) => {
                        return (
                          <li
                            className="bullet-point"
                            key={'item' + j}
                            dangerouslySetInnerHTML={{ __html: bulletPoint }}
                          ></li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
            </div>
          )}
          {textBoxes && (
            <div className="individual-software__textBoxes">{textBoxes}</div>
          )}
          {(lists || textBoxes) && link && linkText && (
            <a href={link} className="cta-round">
              <span>
                <a>{linkText}</a>
              </span>
              <svg viewBox="0 0 13 10" height="10px" width="15px">
                <path d="M1,5 L11,5"></path>
                <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default SplitView
